import { defineStore } from "pinia";

export const useWindowSizeStore = defineStore('windowSizeStore', {
  state : () => ({
    width : 0,
    height : 0,
    osName : "Windows",
    osNumber : 11
  }),
  getters: {
    getWindowSize() {
      //console.log("************    get stored window size -- before return",this.width,this.height)
      return { width : this.width, height : this.height }
    },
    getOSName() {
      //console.log("************    get stored OS Name",this.osName)
      return ( this.osName )
    },
    getOSNumber() {
      //console.log("************    get stored OS Number",this.osNumber)
      return ( this.osNumber )
    }
  },
  actions: {
    updateStoredWindowSize(width, height) {
      //console.log("***** update stored window size ",width,height)
      this.width = width
      this.height = height
    },
    updateStoredOSInfo(name, number) {
      //console.log("***** update stored OS Name and number ",name,number)
      this.osName = name
      this.osNumber = number
    },
  }

})
